import relaxedDuck from "../media/relaxed-duck.png";
import panic from "../media/panic.png";
import coffee from "../media/coffee.png";
import heart from "../media/heart.png";

function WhyTube() {
    return (
        <section className="why-tube" id="about">

            <div className="container">

                <div className="row align-items-center">

                    {/* Left */}

                    <div className="col-lg-6">

                        <div className="why-content">

                            <h2>WHY TUBE ?</h2>

                            <div className="why-item">

                                <img src={panic} alt="" />

                                <span>Everyone is panicking.</span>

                            </div>

                            <div className="why-item">

                                <img src={coffee} alt="" />

                                <span>Tube is drinking coffee.</span>

                            </div>

                            <div className="why-item">

                                <img src={heart} alt="" />

                                <span>That's it.</span>

                            </div>

                        </div>

                    </div>

                    {/* Right */}

                    <div className="col-lg-6">

                        <div className="why-image">

                            <img
                                src={relaxedDuck}
                                alt="Relaxed Tube"
                                className="img-fluid"
                            />

                        </div>

                    </div>

                </div>

            </div>

        </section>
    );
}

export default WhyTube;